export default {
  namespaced: true,
  hanwha_log: {
    title: "DVR Registros",
    dvr: "Gravador (DVR)",
    autoDetectDvr: "Detectar DVR(s) automaticamente",
    autoDetectDvrHint: "Usa o(s) DVR(s) da unidade do alarme automaticamente",
    typeLog: "Tipo de log",
    typeEvent: "Tipo de evento",
    dateRange: "Intervalo de dias",
    dateRangeNone: "Nenhum",
    dateRangeLast30: "Últimos 30 dias",
    dateRangeLast60: "Últimos 60 dias",
    dateRangeHint: "Calculado a partir do momento em que a vista do alarme é aberta",
  },
};
